/* eslint-disable */
import React, { useState } from 'react';
import ArrowDown from '../assets/ArrowDown';
import ArrowUp from '../assets/ArrowUp';
import './Dropdown.scss';
var Dropdown = function (_a) {
    var data = _a.data, placeholder = _a.placeholder, searchable = _a.searchable, selectedValue = _a.selectedValue, setSelectedValue = _a.setSelectedValue, settingsType = _a.settingsType;
    var _b = useState(data), filteredData = _b[0], setFilteredData = _b[1];
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var filterOptions = function (event) {
        var filtered = data.filter(function (option) { return option.toLowerCase().includes(event.target.value.toLowerCase()); });
        setSelectedValue(event.target.currentValue);
        setFilteredData(filtered);
        setOpen(true);
    };
    var handleClick = function (option) {
        setSelectedValue(option);
        setOpen(function (prev) { return !prev; });
        setFilteredData(data);
    };
    return (React.createElement("div", { className: "shared-components-dropdown", onBlur: function () { return setOpen(false); } },
        React.createElement("div", { className: "input-container" },
            React.createElement("input", { type: "text", value: selectedValue, onChange: filterOptions, placeholder: placeholder, readOnly: !searchable }),
            React.createElement("button", { "cy-data": settingsType + "dropdownArrowButtonInCommon-cy", onClick: function () { return setOpen(function (prev) { return !prev; }); } },
                React.createElement(ArrowDown, { show: !open }),
                React.createElement(ArrowUp, { show: open }))),
        open && (React.createElement("div", { className: "option-container", "cy-data": settingsType + "dropdownOptionListInCommon-cy" }, filteredData.map(function (option, index) { return (React.createElement("div", { className: "dropdown-options", key: index, onMouseDown: function (e) { return e.preventDefault(); }, onClick: function () { return handleClick(option); } }, option)); })))));
};
Dropdown.defaultProps = {
    searchable: false
};
export default Dropdown;
